import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  notAssigned: {
    color: '#2188CC',
  },
  NotAssignedStatus: {
    background: '#707070',
    color: '#FFF',
  },
  awaitingPicking: {
    background: '#EAC644',
    color: '#FFF',
  },
  awaitingValidation: {
    background: '#FFE0E0',
    color: '#FFF',
  },
  pickingInprogress: {
    background: '#E6E6F2',
    color: '#FFF',
  },
  closed: {
    background: '#00B894',
    color: '#FFF',
  },
  invoiced: {
    background: '#925CB1',
    color: '#FFF',
  },
  manque: {
    background: '#F8E8FB',
    color: '#FFF',
  },
}));

export default useStyles;
